"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMConstantPool = void 0;
const inversify_1 = require("inversify");
let VMConstantPool = class VMConstantPool {
    constructor() {
        this.constants = [];
        this.constantMap = new Map();
    }
    add(value) {
        const key = this.getConstantKey(value);
        const existingIndex = this.constantMap.get(key);
        if (existingIndex !== undefined) {
            return existingIndex;
        }
        const newIndex = this.constants.length;
        this.constants.push(value);
        this.constantMap.set(key, newIndex);
        return newIndex;
    }
    forceAdd(value) {
        const newIndex = this.constants.length;
        this.constants.push(value);
        return newIndex;
    }
    get(index) {
        return this.constants[index];
    }
    getAll() {
        return [...this.constants];
    }
    getLength() {
        return this.constants.length;
    }
    clear() {
        this.constants = [];
        this.constantMap.clear();
    }
    reset() {
        this.clear();
    }
    getConstantKey(value) {
        if (value === null) {
            return 'null';
        }
        if (value === undefined) {
            return 'undefined';
        }
        if (value instanceof RegExp) {
            return `regex:${value.source}:${value.flags}`;
        }
        const type = typeof value;
        switch (type) {
            case 'string':
                return `string:${value}`;
            case 'number':
                return `number:${value}`;
            case 'bigint':
                return `bigint:${value}`;
            case 'boolean':
                return `boolean:${value}`;
            default:
                return `unknown:${String(value)}`;
        }
    }
};
exports.VMConstantPool = VMConstantPool;
exports.VMConstantPool = VMConstantPool = __decorate([
    (0, inversify_1.injectable)()
], VMConstantPool);
